export function readEmbeddedAuthoringRuntime(code) {
    return findEmbeddedRecord(code, 'runtime')?.value ?? null;
}
export function readEmbeddedAuthoringStyle(code) {
    return findEmbeddedRecord(code, 'style')?.value ?? null;
}
export function readEmbeddedAuthoringRendererSource(code) {
    const runtimeMatch = findEmbeddedRecord(code, 'runtime');
    if (!runtimeMatch)
        return null;
    const sourceStart = code.indexOf('(');
    const engineTerminator = '})(globalThis);';
    const terminatorStart = code.lastIndexOf(engineTerminator, runtimeMatch.assignmentStart);
    if (sourceStart < 0 || terminatorStart <= sourceStart)
        return null;
    let sourceEnd = terminatorStart + engineTerminator.length;
    if (code.startsWith('\r\n', sourceEnd)) {
        sourceEnd += 2;
    }
    else if (code[sourceEnd] === '\n') {
        sourceEnd += 1;
    }
    return code.slice(sourceStart, sourceEnd);
}
function findEmbeddedRecord(code, name) {
    const assignmentPattern = new RegExp(`\\bconst\\s+${name}\\s*=\\s*`, 'g');
    let result = null;
    let match = assignmentPattern.exec(code);
    while (match) {
        const value = readJsonRecord(code, match.index + match[0].length);
        if (value) {
            result = { assignmentStart: match.index, value };
        }
        match = assignmentPattern.exec(code);
    }
    return result;
}
function readJsonRecord(source, start) {
    if (source[start] !== '{')
        return null;
    let depth = 0;
    let escaped = false;
    let inString = false;
    for (let index = start; index < source.length; index += 1) {
        const character = source[index];
        if (inString) {
            if (escaped) {
                escaped = false;
            }
            else if (character === '\\') {
                escaped = true;
            }
            else if (character === '"') {
                inString = false;
            }
            continue;
        }
        if (character === '"') {
            inString = true;
        }
        else if (character === '{' || character === '[') {
            depth += 1;
        }
        else if (character === '}' || character === ']') {
            depth -= 1;
            if (depth === 0) {
                try {
                    const value = JSON.parse(source.slice(start, index + 1));
                    return isRecord(value) ? value : null;
                }
                catch {
                    return null;
                }
            }
        }
    }
    return null;
}
function isRecord(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
//# sourceMappingURL=embedded-runtime.js.map